import React, { useEffect, useState } from 'react';
import { useActionData, useSubmit } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ReportsSearcher from '../../ReportsSearcher/ReportsSearcher';
import {
  formatShortDate,
  getCurrentFormattedDate,
  getCurrentTimeZone,
} from '../utils/helpers';
import BusinessOverviewPDF from '../../../PDF/ReportsPDFGenerator/BusinessOverview/BusinessOverviewPDF';
import { getCompanyInfo } from '../../../../routes/reports/reportsLA';

function ProfitLossReport() {
  const [fetchedData, setFetchedData] = useState(false);
  const [data, setData] = useState({});
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [enablePrintDownload, setEnablePrintDownload] = useState(false);
  const [userCompany, setUserCompany] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (toDate && fromDate !== '') {
      setEnablePrintDownload(true);
    }
    setFetchedData(false);
  }, [fromDate, toDate]);

  const submit = useSubmit();
  const actionData = useActionData();

  useEffect(() => {
    if (actionData !== undefined) {
      setData(actionData);
      setFetchedData(true);
    }
  }, [actionData]);

  const handleRunReport = async () => {
    setLoading(true);
    // const values = new FormData();
    // values.append('from', fromDate);
    // values.append('to', toDate);
    const values = {
      from: fromDate,
      to: toDate,
    };
    submit(values, { method: 'post', encType: 'application/json' });
    setLoading(false);
  };

  const getUserCompany = async () => {
    const { user } = await getCompanyInfo();
    setUserCompany(user.user_company);
  };

  useEffect(() => {
    getUserCompany();
  }, []);

  const pdfFile = (
    <BusinessOverviewPDF
      fetchedData={data}
      title="Profit and Loss Report"
      profitLossReport
      from={formatShortDate(fromDate)}
      to={formatShortDate(toDate)}
      currentDate={getCurrentFormattedDate()}
      timezone={getCurrentTimeZone()}
      userCompany={userCompany}
    />
  );

  return (
    <div>
      <ReportsSearcher
        title="Report Period"
        pdfFileName="profit-and-loss-report"
        setFromDate={setFromDate}
        setToDate={setToDate}
        fromDate={fromDate}
        toDate={toDate}
        enablePrintDownload={enablePrintDownload}
        pdfChildren={pdfFile}
        handleRunReport={enablePrintDownload ? handleRunReport : () => {}}
        loading={loading}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 40,
        }}
      >
        {fetchedData && (
          <PDFViewer height={705} width={500} showToolbar={false}>
            {pdfFile}
          </PDFViewer>
        )}
      </div>
    </div>
  );
}

export default ProfitLossReport;
